export const searchObj = state => state.searchObj
export const newAddress = state => state.newAddress
export const areaCode = state => state.areaCode
export const userInfo = state => state.userInfo
export const currentPro = state => state.currentPro
export const shoppingCart = state => state.shoppingCart
export const cartNumber = state => state.cartNumber
export const noticeId = state => state.noticeId
export const collectData = state => state.collectData
export const city_location = state => state.city_location
export const classify = state => state.classify
export const componentContent = state => state.componentContent
export const componentContentB2c = state => state.componentContentB2c
export const shopsData = state => state.shopsData
export const platform = state => state.platform



// WEBPACK FOOTER //
// ./src/store/getter.js